namespace Matrix.Data {
    export interface CurrencyRow {
        CurrencyCode?: string;
        Name?: string;
        DefaultSortOrder?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        RowId?: number;
        Version?: number;
    }

    export namespace CurrencyRow {
        export const idProperty = 'CurrencyCode';
        export const nameProperty = 'CurrencyCode';
        export const localTextPrefix = 'Data.Currency';
        export const lookupKey = 'Data.Currency';

        export function getLookup(): Q.Lookup<CurrencyRow> {
            return Q.getLookup<CurrencyRow>('Data.Currency');
        }
        export const deletePermission = 'DataAdmin:Currency';
        export const insertPermission = 'DataAdmin:Currency';
        export const readPermission = 'Read:Currency';
        export const updatePermission = 'DataAdmin:Currency';

        export declare const enum Fields {
            CurrencyCode = "CurrencyCode",
            Name = "Name",
            DefaultSortOrder = "DefaultSortOrder",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            RowId = "RowId",
            Version = "Version"
        }
    }
}
